module.exports = __webpack_public_path__ + "static/hl-infographic-63411b1c63b719a483b9034143ed5c89.png";